export default "__VITE_ASSET__D$FZSrEv__"